import type { BaseDocument } from '../mongo/base-document.interface';

export const EMAIL_STATUS = {
  ERROR: 'error',
  PENDING: 'pending',
  SENT: 'sent',
} as const;

export type EmailStatus = (typeof EMAIL_STATUS)[keyof typeof EMAIL_STATUS];

export interface EmailEvent {
  event: string;
  reason: string;
}

export interface EmailTemplate extends BaseDocument {
  templateId: string;
  templateName: string;
}

export interface EmittedEmail extends BaseDocument {
  events: EmailEvent[];
  identifiers: Record<string, string>;
  responseTopic: string;
  sgMessageId: string;
  status: EmailStatus;
  templateData: Record<string, string>;
  templateName: string;
  to: string;
}
